import { Injectable, NgZone } from '@angular/core';
import { MapContextMenuEvents, MobileNavigationEvent } from 'src/app/core/events/events';
import { AppService } from '../app-service/app.service';
import { ILatLng } from 'src/app/core/models/google-map-models';
import { EventsService } from 'src/app/core/services/events.service';
import { AALocationModel } from 'src/app/modules/route-planner/models/route-model';
import { Enums } from 'src/app/modules/route-planner/enums/route.enum';
import { Router } from '@angular/router';
import { AARouterURL } from 'src/app/modules/app-routing/enums/routing.enum';
import { RouteDataStoreService } from '../data-store/data-store.service';
import { RoutePlannerEventTrackerService } from '../route-planner-event-tracker/route-planner-event-tracker.service';
import { IMobileNavigationEventModel } from 'src/app/core/models/models';
import { AppUtilityService } from 'src/app/core/services/app-utility/app-utility.service';

@Injectable({
  providedIn: 'root'
})
export class NativeEventsService {

  constructor(private appService: AppService,
    private appUtilityService: AppUtilityService,
    private routePlannerEventTrackerService: RoutePlannerEventTrackerService,
    private router: Router,
    private ngZone: NgZone,
    private dataStore: RouteDataStoreService,
    private eventsService: EventsService) {
    this.googleMapNativeEventHandler();
  }

  private googleMapNativeEventHandler(): void {

    window[MapContextMenuEvents.UPDATE_FROM_LOCATION] = (name, lat, lng) => {
      if (lat && lng) {
        const latLng: ILatLng = {lat: lat, lng: lng};
        this.fetchAddressByLatLan(latLng, Enums.RouteType.FromDestination);
      }
    };

    window[MapContextMenuEvents.UPDATE_TO_LOCATION] = (name, lat, lng) => {
      if (lat && lng) {
        const latLng: ILatLng = {lat: lat, lng: lng};
        this.fetchAddressByLatLan(latLng, Enums.RouteType.ToDestination);
      }
    };
  }

  private fetchAddressByLatLan(latLng: ILatLng, routeType: Enums.RouteType): void {
    this.appService.getGeoLocationByLatLng(latLng).subscribe( result => {

      const locationModel = new AALocationModel(decodeURIComponent(result.locationName), latLng.lat, latLng.lng, routeType);
      locationModel.PlaceId = result.placeId;

      this.navigateToRoutePlanner(locationModel);
      this.eventsService.dispatch(MapContextMenuEvents.UPDATE_TO_LOCATION, {locationModel: locationModel});
    });
  }

  private navigateToRoutePlanner(locationModal: AALocationModel): void {
    const queryParams: any = {};

    if (this.dataStore.fromLocation.validName()) {
      queryParams[AARouterURL._FROM] = this.dataStore.fromLocation.Name;
    } else {
      queryParams[AARouterURL._FROM] = this.dataStore.currentLocation.Name;
    }

    if (this.dataStore.toLocation.validName()) {
      queryParams[AARouterURL._TO] = this.dataStore.toLocation.Name;
    }

    if (locationModal.RouteType === Enums.RouteType.FromDestination) {
        this.dataStore.fromLocation.clear();
        this.dataStore.fromLocation.apply(locationModal);

        queryParams[AARouterURL._FROM] = locationModal.Name;
    } else if (locationModal.RouteType === Enums.RouteType.ToDestination) {
        this.dataStore.toLocation.clear();
        this.dataStore.toLocation.apply(locationModal);

        queryParams[AARouterURL._TO] = locationModal.Name;
    }

    this.ngZone.run( () =>
      this.router.navigate([AARouterURL.ROUTE_PLANNER], {queryParams: queryParams})
    ).then();

    // reset mobile navigation when its mobile.
    if (this.appUtilityService.isMobile) {
      this.ngZone.run( () => {
        const data: IMobileNavigationEventModel = {ActivePage: AARouterURL.ROUTE_PLANNER, ActiveTab: AARouterURL.ROUTE_PLANNER};
        this.eventsService.dispatch(MobileNavigationEvent.SELECT_MOBILE_MENU, data);
      });
    }
  }

}
